export default "__VITE_ASSET__DA5d5hhO__"